module.exports = __webpack_public_path__ + "img/doorLogo12.5f31a92a.png";